import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

const Avatar = (theme: Theme) => {
  return {
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: alpha(theme.palette.grey[500], 0.24),
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiAvatarGroup: {
      defaultProps: {
        max: 4,
      },
      styleOverrides: {
        avatar: {
          '&:first-of-type': {
            backgroundColor: theme.palette.primary.lighter,
            color: theme.palette.primary.main,
            fontSize: 12,
          },
          fontSize: 16,
          fontWeight: theme.typography.fontWeightMedium,
        },
        root: {
          justifyContent: 'flex-end',
        },
      },
    },
  };
};

export default Avatar;
